import { render } from "./editdepartement.vue?vue&type=template&id=20d73985"
import script from "./editdepartement.vue?vue&type=script&lang=js"
export * from "./editdepartement.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__